// components/SubscriptionAlert.tsx
import React from "react";
import { useAuth } from "../AuthContext";
import "../style/css/SubscriptionAlert.css";

export const SubscriptionAlert: React.FC = () => {
  const { subscriptionInfo, user } = useAuth();

  if (!subscriptionInfo || subscriptionInfo.active) {
    return null; // No mostrar si no hay info o si está activa
  }

  const getAlertMessage = () => {
    switch (subscriptionInfo.status) {
      case "no_clinic":
        return "Tu cuenta no tiene una clínica asociada. Por favor, contacta al soporte.";
      case "no_subscription":
        return "Tu clínica no tiene una suscripción activa. Por favor, selecciona un plan.";
      case "paused":
        return "Tu suscripción está pausada. Reactívala para continuar usando todos los features.";
      case "canceled":
        return "Tu suscripción ha sido cancelada. Renueva tu plan para continuar.";
      default:
        return "Tu suscripción no está activa. Por favor, actualiza tu plan.";
    }
  };

  const getAlertType = () => {
    switch (subscriptionInfo.status) {
      case "no_clinic":
        return "error";
      case "no_subscription":
        return "warning";
      case "paused":
        return "warning";
      case "canceled":
        return "error";
      default:
        return "warning";
    }
  };

  const alertType = getAlertType();
  const message = getAlertMessage();

  return (
    <div className={`subscription-alert subscription-alert--${alertType}`}>
      <div className="subscription-alert__overlay">
        <div className="subscription-alert__modal">
          <div className="subscription-alert__header">
            <div className="subscription-alert__icon">
              <div className={`icon icon--${alertType}`}>
                {alertType === "error" ? "!" : "!"}
              </div>
            </div>
            <h3 className="subscription-alert__title">Estado de Suscripción</h3>
          </div>

          <div className="subscription-alert__content">
            <p className="subscription-alert__message">{message}</p>
            {subscriptionInfo.clinic_name && (
              <div className="subscription-alert__clinic">
                <strong>Clínica:</strong> {subscriptionInfo.clinic_name}
              </div>
            )}
          </div>

          <div className="subscription-alert__actions">
            {(subscriptionInfo.status === "no_subscription" ||
              subscriptionInfo.status === "canceled") && (
              <button
                className="btn btn--primary"
                onClick={() => (window.location.href = "/plans")}
              >
                Ver Planes
              </button>
            )}
            {subscriptionInfo.status === "paused" && (
              <button
                className="btn btn--primary"
                onClick={() => (window.location.href = "/billing")}
              >
                Reactivar
              </button>
            )}
            <button
              className="btn btn--secondary"
              onClick={() => (window.location.href = "/support")}
            >
              Contactar Soporte
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
